<template>
  <div id="gota-kanal-route-page-app">
    <SiteHeader />
    <RoutePage :route-page="routePage" />
  </div>
</template>

<script setup lang="ts">
import SiteHeader from "@shared/Layout/SiteHeader/SiteHeader.vue";
import RoutePage from "./RoutePage.vue";

const routePage: RoutePagePayload = window.__litium?.routePage ?? {
  guid: "",
  price: "",
  title: "",
  introduction: "",
  imageUrl: "",
  imageSrcSet: "",
  imageSizes: "",
  imageAltText: "",
  productSystemId: "",
  ticket: null,
  upperBlocks: [],
  lowerBlocks: [],
};
</script>
